import { MyProfile } from './myProfile';

require('./myProfile.scss');

export const myProfileComponent = {
  template: require('./myProfile.html'),
  controllerAs: 'ctrl',
  controller: MyProfile,
};
